/* [DV-STOK-ALARM 2026-08-03]
   "Stokta olduğunda bana bildir" formunu sunucudaki abone kaydına bağlar.

   NEDEN: Tema bloğu (snippets/back-instock.liquid) Shopify'ın jenerik `contact`
   formudur — YALNIZCA mağazaya mail atar. Müşteriye geri dönecek hiçbir kayıt
   tutulmuyordu. Bu dosya, formun kendi davranışını BOZMADAN (mağaza maili aynen
   gitmeye devam eder) aynı bilgiyi sunucuya da yazar.

   Akış: submit yakalanır → sunucuya POST → sonuç ne olursa olsun (en geç 2.5sn)
   formun kendi gönderimi devam eder. Sunucu erişilemezse davranış bugünküyle
   birebir aynıdır.
*/
(function () {
  'use strict';
  if (window.__DV_STOK_ALARM__) return;
  window.__DV_STOK_ALARM__ = true;
  if (location.pathname.indexOf('/products/') === -1) return;

  var UC = 'https://dolcevita-massimo.ngrok.io/api/tracking/public/stok-alarm';
  var BEKLEME_MS = 2500;

  function meta() {
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      return (m && m.product && m.product.id) ? m : null;
    } catch (e) { return null; }
  }

  function handleCoz(m) {
    if (m && m.product && m.product.handle) return String(m.product.handle);
    var t = /\/products\/([^/?#]+)/.exec(location.pathname);
    if (!t) return '';
    try { return decodeURIComponent(t[1]); } catch (e) { return t[1]; }
  }

  /* Seçili tükenmiş varyant: önce bloğun kendi select'i, yoksa tek varyantlı ürün. */
  function varyantCoz(kutu, m) {
    var sel = kutu.querySelector('select[back-instock-select]');
    if (sel && sel.value) {
      var etiket = '';
      try {
        var o = sel.options[sel.selectedIndex];
        etiket = o ? String(o.textContent || '').trim() : '';
      } catch (e) { etiket = ''; }
      return { vid: String(sel.value), olcu: etiket };
    }
    try {
      var vs = (m && m.product && m.product.variants) || [];
      if (vs.length === 1) return { vid: String(vs[0].id), olcu: String(vs[0].name || '') };
      if (m && m.selectedVariantId) return { vid: String(m.selectedVariantId), olcu: '' };
    } catch (e) { /* yut */ }
    return { vid: '', olcu: '' };
  }

  function baglaformu(kutu) {
    var form = kutu.querySelector('form');
    if (!form || form.__dvStokBagli) return;
    form.__dvStokBagli = true;

    form.addEventListener('submit', function (ev) {
      if (form.__dvDevam) return;              // ikinci geçiş: normal gönderime bırak
      var m = meta();
      var epostaEl = form.querySelector('input[name="contact[email]"]');
      var eposta = epostaEl ? String(epostaEl.value || '').trim() : '';
      var v = varyantCoz(kutu, m);

      if (!eposta || !v.vid) return;           // veri yoksa karışma, form normal aksın

      ev.preventDefault();

      var bitti = false;
      function devamEt() {
        if (bitti) return;
        bitti = true;
        form.__dvDevam = true;
        try { form.submit(); } catch (e) { /* yut */ }
      }
      var sayac = setTimeout(devamEt, BEKLEME_MS);

      var govde = {
        eposta: eposta,
        pid: m && m.product ? String(m.product.id) : '',
        vid: v.vid,
        h: handleCoz(m),
        olcu: v.olcu,
        c: '1'                                  // formun kendisi bildirim talebidir
      };

      try {
        fetch(UC, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(govde),
          mode: 'cors',
          credentials: 'omit'
        }).then(function () { clearTimeout(sayac); devamEt(); })
          .catch(function () { clearTimeout(sayac); devamEt(); });
      } catch (e) {
        clearTimeout(sayac); devamEt();
      }
    }, true);
  }

  function kur() {
    var kutular = document.querySelectorAll('hdt-back-instock');
    for (var i = 0; i < kutular.length; i++) baglaformu(kutular[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }
  /* Varyant değişiminde blok yeniden çizilebilir; hafif bir gözcü yeterli. */
  try {
    new MutationObserver(function () { kur(); })
      .observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* yut */ }
})();
